export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";